import { useState, useEffect, useContext } from 'react';
import {arrayMoveImmutable} from 'array-move';
import { DragEndEvent } from '@dnd-kit/core';

import {
    // closestCenter,
    // DndContext,
    // DragStartEvent,
    // DragOverlay,
    MouseSensor,
    TouchSensor,
    KeyboardSensor,
    useSensor,
    useSensors,
    // SensorDescriptor,
    // SensorOptions
} from '@dnd-kit/core';


import {
    sortableKeyboardCoordinates,
    // SortableContext,
    // verticalListSortingStrategy,
} from '@dnd-kit/sortable';



import { UuidType } from 'utils/types';
import useUserIdentity from './useUserIdentity';
import { SortableContext } from 'contexts/sortable_context';


export function useSortable(slug: string) {
    const [items, setStateItems] = useState<UuidType[]>([]);
    const { currentIdentity } = useUserIdentity();
    const {
        setSortable,
        getSortable,
        fetchSortable,
        getSorted,
        sortableItems
    } = useContext(SortableContext);
    const [itemOrder, setItemOrder] = useState<string[]>(getSortable(slug) || []);

    // const itemOrder = getSortable(slug) || [];
    // console.log("itemOrder init", itemOrder);

    const sensors = useSensors(
        useSensor(MouseSensor, {
            activationConstraint: { distance: 15 }
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                delay: 200,
                tolerance: 6,
            },
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    useEffect(() => {
        fetchSortable(slug);
    }, [slug, currentIdentity?.uuid]);

    useEffect(() => {
        // console.log("useSortable: sortableItems", sortableItems);
        // console.log("useSortable: getSortable changed", getSortable(slug));
        setItemOrder(getSortable(slug) || []);
    }, [sortableItems]);

    const getSortedWrapper = () => {
        return getSorted(slug, items);
    };

    const onSortEnd = (event: DragEndEvent) => {
        const {active, over} = event;
        const oldIndex = itemOrder.indexOf(active.id.toString());
        const newIndex = over ? itemOrder.indexOf(over.id.toString()) : 0;
        const newItems = arrayMoveImmutable(items, oldIndex, newIndex);

        // console.log(`oldIndex: ${oldIndex}, newIndex: ${newIndex}`)
        // console.log("Setting sortable for unsorted:", itemOrder);
        // var newItems = [...items];
        // console.log("Starting with items: ", items.map((p) => p.uuid));
        // const [removed] = newItems.splice(oldIndex, 1);
        // newItems.splice(newIndex, 0, removed);
        // // setStateItems(newItems);
        const order = newItems.map((p) => p.uuid);
        // setItemOrder(order);

        // Save it to local storage
        setSortable(slug, order);

        // the orderd won't be set in state in time, so we send it along
        updateStateItems(newItems as UuidType[], order);
        // forageSet(slug, storedOrder);
    };

    function updateStateItems(newItems: UuidType[], order?: string[] | undefined) {
        // We can use the one we have stored or you can provide one
        if(order === undefined) {
            order = itemOrder;
        }
        if (newItems.length > 0) {

            // 1. Sort the projects based on itemOrder
            function cmp(a: UuidType, b: UuidType) {
                if(order === undefined) return 0;
                var aIndex = order.indexOf(a.uuid);
                var bIndex = order.indexOf(b.uuid);
                aIndex = aIndex === -1 ? Infinity : aIndex;
                bIndex = bIndex === -1 ? Infinity : bIndex;
                return aIndex - bIndex;
            }
            const sortedItems = newItems.sort(cmp);
            setStateItems(sortedItems as UuidType[]);
        }
    }

    return {
        onSortEnd,
        items,
        sensors,
        getSortable: () => getSortable(slug),
        setSortable,
        getSorted: getSortedWrapper,
        updateItems: updateStateItems };
}

export default useSortable;
